import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon, Modal } from 'antd';
import TextEvents from 'app/components/TextEvents';
import TextInput from 'app/components/TextInput';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../../UserSearchScreenStyles';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { debounce } from 'debounce';

import { employeeById } from 'app/reducers';
import TechnicalRepresentativeContainer from 'app/containers/TechnicalRepresentativeContainer';

const InternalEmployeesFilterComponent = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    //Datos gurdados en el estado del modulo para uso de filtros
    const [employeesNames, setEmployeesNames] = useState([]);
    const [employeesSubdirection, setEmployeesSubdirection] = useState([]);
    const [employeesId, setEmployeesId] = useState([]);
    const [employeesCompany, setEmployeesCompany] = useState([]);
    const [employeesCategory, setEmployeesCategory] = useState([]);
    const [employeesContract, setEmployeesContract] = useState([]);
    const [employeesOt, setEmployeesOt] = useState([]);
    const [employeesEmail, setEmployeesEmail] = useState([]);
    const [employeesCeco, setEmployeesCeco] = useState([]);
    const [employeesEpep, setEmployeesEpep] = useState([]);
    const [isEmployeeActive, setEmployeeActive] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [employeePercnota, setEmployeePercnota] = useState([]);
    const [employeeComunicationProgram, setEmployeeComunicationProgram] = useState([]);
    const [employeeCourses, setEmployeeCourses] = useState([]);

    const employeeData = useSelector(employeeById)
    const [openModal, setOpenModal] = useState(false);
    const [revisor, setRevisor] = useState("");
    const { Option } = Select;

    useEffect(() => {
        dispatch(UserSearchActions.getInternalComunicationPrograms());
        dispatch(UserSearchActions.getInternalCourses());
    }, []);


    //Datos del store de redux
    const {
        listInternalEmployeesNames,
        isLoadingInternalEmployeesNames,

        isLoadingSubdirection,
        listInternalEmployeesSubdirection,

        isLoadingEmployeeId,
        listInternalEmployeesId,

        isLoadingEmployeeCompany,
        listInternalEmployeesCompany,

        isLoadingEmployeeCategory,
        listInternalEmployeesCategory,

        isLoadingContract,
        listInternalEmployeesContract,

        isLoadingOT,
        listInternalEmployeesOT,

        isLoadingInternalEmail,
        listInternalEmployeesEmail,

        isLoadingIECeco,
        listInternalEmployeesCeco,

        isLoadingIEEpep,
        listInternalEmployeesEpep,

        filter,
        pagination,

        isExportingXls,
        isExportingBookmarkXls,

        isLoadingPernocta,
        listPercnota,

        listCourses,
        isLoadingCourses,

        listComunicationProgram,
        isLoadingComunicationProgram,

    } = useSelector(state => state.UserSearchReducer);

    //Filtro: Nombre Empleado
    const optionInternalEmployeesNames = listInternalEmployeesNames.map((item) =>
        (<Select.Option key={item.value} value={item.value} /*key={item.key} value={item.key}*/>{item.value}</Select.Option>)
    );

    //Filtro: Nombre Subdirecciones
    const optionInternalEmployeesSubdirection = listInternalEmployeesSubdirection.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Fucha de Empleado
    const optionInternalEmployeesId = listInternalEmployeesId.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Nombre Compañias
    const optionInternalEmployeesCompany = listInternalEmployeesCompany.map((item) =>
        (<Select.Option key={item.value} value={item.value} /*key={item.key} value={item.key}*/>{item.value}</Select.Option>)
    );

    //Filtro: Nombre Categorias
    const optionInternalEmployeesCategory = listInternalEmployeesCategory.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Listado de contratos disponibles
    const optionInternalEmployeesContract = listInternalEmployeesContract.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Listado de Ots disponibles
    const optionInternalEmployeesOT = listInternalEmployeesOT.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Correos de empleados
    const optionInternalEmployeesEmail = listInternalEmployeesEmail.map((item) =>
        (<Select.Option key={item.value} value={item.value} /*key={item.key} value={item.key}*/>{item.value}</Select.Option>)
    );

    //Filtro: Listado de CeCo disponibles
    const optionInternalEmployeesCeco = listInternalEmployeesCeco.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Listado de EPEP disponibles
    const optionInternalEmployeesEpep = listInternalEmployeesEpep.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Filtro: Percnota
    const optionInternalEmployeesPercnota = listPercnota.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );
    //Filtro: CommunicationProgram
    const optionInternalComunicationProgram = listComunicationProgram.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );
    //Filtro: Courses
    const optionInternalCourses = listCourses.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    //Cambio en seleccion de filtro nombres
    const onEmployeesCoursesChanges = (courses) => {
        setEmployeeCourses(courses);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: courses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro nombres
    const onEmployeesComunicationProgramChanges = (cm) => {
        setEmployeeComunicationProgram(cm);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: cm,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro nombres
    const onEmployeesNamesChange = (names) => {
        setEmployeesNames(names);
        const obj = {
            listInternalEmployeesNames: names,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro subdirecciones
    const onEmployeesSubdirectionChange = (subdirection) => {
        setEmployeesSubdirection(subdirection);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: subdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro fichas
    const onEmployeesIdChange = (ids) => {
        setEmployeesId(ids);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: ids,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro compañia
    const onEmployeesCompanyChange = (company) => {
        setEmployeesCompany(company);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: company,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro categoria
    const onEmployeesCategoryChange = (category) => {
        setEmployeesCategory(category);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: category,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,

        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro contrato
    const onEmployeesContractChange = (contract) => {
        setEmployeesContract(contract);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: contract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,

        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro Ot
    const onEmployeesOtChange = (ot) => {
        setEmployeesOt(ot);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: ot,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro correo electronico
    const onEmployeesEmailChange = (email) => {
        setEmployeesEmail(email);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: email,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro CECO
    const onEmployeesCecoChange = (ceco) => {
        setEmployeesCeco(ceco);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: ceco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro EPEP
    const onEmployeesEpepChange = (epep) => {
        setEmployeesEpep(epep);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: epep,
            listIsActive: isEmployeeActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de filtro Active
    const onEmployeesActiveStausChange = (_isActive) => {
        setEmployeeActive(_isActive);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: _isActive,
            listPercnota: employeePercnota,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Cambio en seleccion de pernocta
    const onEmployeesPernoctaChange = (pernocta) => {
        setEmployeePercnota(pernocta);
        const obj = {
            listInternalEmployeesNames: employeesNames,
            listInternalEmployeesSubdirection: employeesSubdirection,
            listInternalEmployeesCategory: employeesCategory,
            listInternalEmployeesId: employeesId,
            listInternalEmployeesCompany: employeesCompany,
            listInternalEmployeesContract: employeesContract,
            listInternalEmployeesOT: employeesOt,
            listInternalEmployeesEmail: employeesEmail,
            listInternalEmployeesCeco: employeesCeco,
            listInternalEmployeesEpep: employeesEpep,
            listIsActive: isEmployeeActive,
            listPercnota: pernocta,
            listComunicationProgram: employeeComunicationProgram,
            listCourses: employeeCourses,
        }

        dispatch(UserSearchActions.saveFilter(obj));
    }

    //Accion clic botón buscar
    const search = () => {
        dispatch(UserSearchActions.fetchInternalEmployees({
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listSubdirections: filter.listInternalEmployeesSubdirection.length > 0 ? filter.listInternalEmployeesSubdirection.join("|") : '',
            listNames: filter.listInternalEmployeesNames.length > 0 ? filter.listInternalEmployeesNames.join("|") : '',
            listFiles: filter.listInternalEmployeesId.length > 0 ? filter.listInternalEmployeesId.join("|") : '',
            listCompanys: filter.listInternalEmployeesCompany.length > 0 ? filter.listInternalEmployeesCompany.join("|") : '',
            listJobs: filter.listInternalEmployeesCategory.length > 0 ? filter.listInternalEmployeesCategory.join("|") : '',
            listContracts: filter.listInternalEmployeesContract.length > 0 ? filter.listInternalEmployeesContract.join("|") : '',
            listOTs: filter.listInternalEmployeesOT.length > 0 ? filter.listInternalEmployeesOT.join("|") : '',
            listEmails: filter.listInternalEmployeesEmail.length > 0 ? filter.listInternalEmployeesEmail.join("|") : '',
            listCeco: filter.listInternalEmployeesCeco.length > 0 ? filter.listInternalEmployeesCeco.join("|") : '',
            listEpep: filter.listInternalEmployeesEpep.length > 0 ? filter.listInternalEmployeesEpep.join("|") : '',
            listIsActive: filter.listIsActive.length > 0 ? filter.listIsActive.join("|") : '',
            listPernocta: filter.listPercnota.length > 0 ? filter.listPercnota.join("|") : '',
            listIdCommunication: filter.listComunicationProgram.length > 0 ? filter.listComunicationProgram.join("|") : '',
            listIdCourse: filter.listCourses.length > 0 ? filter.listCourses.join("|") : '',
        }));
    }

    const exportGenerate = () => {
        
        var payload = {
            IsExternal: false,
            listSubdirections: filter.listInternalEmployeesSubdirection.length > 0 ? filter.listInternalEmployeesSubdirection.join("|") : '',
            listNames: filter.listInternalEmployeesNames.length > 0 ? filter.listInternalEmployeesNames.join("|") : '',
            listFiles: filter.listInternalEmployeesId.length > 0 ? filter.listInternalEmployeesId.join("|") : '',
            listCompanys: filter.listInternalEmployeesCompany.length > 0 ? filter.listInternalEmployeesCompany.join("|") : '',
            listJobs: filter.listInternalEmployeesCategory.length > 0 ? filter.listInternalEmployeesCategory.join("|") : '',
            listContracts: filter.listInternalEmployeesContract.length > 0 ? filter.listInternalEmployeesContract.join("|") : '',
            listOTs: filter.listInternalEmployeesOT.length > 0 ? filter.listInternalEmployeesOT.join("|") : '',
            listEmails: filter.listInternalEmployeesEmail.length > 0 ? filter.listInternalEmployeesEmail.join("|") : '',
            listCeco: filter.listInternalEmployeesCeco.length > 0 ? filter.listInternalEmployeesCeco.join("|") : '',
            listEpep: filter.listInternalEmployeesEpep.length > 0 ? filter.listInternalEmployeesEpep.join("|") : '',
            listIsActive: filter.listIsActive.length > 0 ? filter.listIsActive.join("|") : '',
            listPernocta: filter.listPercnota.length > 0 ? filter.listPercnota.join("|") : '',
            listIdCommunication: filter.listComunicationProgram.length > 0 ? filter.listComunicationProgram.join("|") : '',
            listIdCourse: filter.listCourses.length > 0 ? filter.listCourses.join("|") : '',
            elaborador: `${employeeData.firstName} ${employeeData.lastName}`,
            revisor: revisor
        }

        dispatch(UserSearchActions.exportBookmark(payload, "Internos"))
        setOpenModal(false);
        setRevisor("");
    }

    //Accion clic de botón exportar
    const exportXls = () => {
        dispatch(UserSearchActions.exportXls({
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listSubdirections: filter.listInternalEmployeesSubdirection.length > 0 ? filter.listInternalEmployeesSubdirection.join("|") : '',
            listNames: filter.listInternalEmployeesNames.length > 0 ? filter.listInternalEmployeesNames.join("|") : '',
            listFiles: filter.listInternalEmployeesId.length > 0 ? filter.listInternalEmployeesId.join("|") : '',
            listCompanys: filter.listInternalEmployeesCompany.length > 0 ? filter.listInternalEmployeesCompany.join("|") : '',
            listJobs: filter.listInternalEmployeesCategory.length > 0 ? filter.listInternalEmployeesCategory.join("|") : '',
            listContracts: filter.listInternalEmployeesContract.length > 0 ? filter.listInternalEmployeesContract.join("|") : '',
            listOTs: filter.listInternalEmployeesOT.length > 0 ? filter.listInternalEmployeesOT.join("|") : '',
            listEmails: filter.listInternalEmployeesEmail.length > 0 ? filter.listInternalEmployeesEmail.join("|") : '',
            listCeco: filter.listInternalEmployeesCeco.length > 0 ? filter.listInternalEmployeesCeco.join("|") : '',
            listEpep: filter.listInternalEmployeesEpep.length > 0 ? filter.listInternalEmployeesEpep.join("|") : '',
            listIsActive: filter.listIsActive.length > 0 ? filter.listIsActive.join("|") : '',
            listPernocta: filter.listPercnota.length > 0 ? filter.listPercnota.join("|") : '',
            listIdCommunication: filter.listComunicationProgram.length > 0 ? filter.listComunicationProgram.join("|") : '',
            listIdCourse: filter.listCourses.length > 0 ? filter.listCourses.join("|") : '',
        }));
    }

    //Funcion para filtrar nombres
    const handleSearchName = name => {
        //if (name !== '') {
        dispatch(UserSearchActions.getInternalEmployeesNames(name));
        //}
    }


    //Funcion para filtrar fichas
    const handleSearchFile = file => {
        // if (file !== '') {
        dispatch(UserSearchActions.getInternalEmployeesId(file));
        //}
    }

    //Funcion para filtrar categorias
    const handleSearchCategory = cat => {
        //if (cat !== '') {
        dispatch(UserSearchActions.getInternalEmployeesCategory(cat));
        //}
    }

    //Funcion para filtrar emails
    const handleSearchEmail = email => {
        //    if (email !== '') {
        dispatch(UserSearchActions.getInternalEmployeesEmail(email));
        //  }
    }

    //Funcion para filtrar pernocta
    const handleSearchPernocta = (pernocta) => {
        //    if (email !== '') {
        dispatch(UserSearchActions.getInternalPernoctas());
        //  }
    }

    //Funcion para filtrar courses
    const handleSearchCourses = (courses) => {
        //    if (email !== '') {
        dispatch(UserSearchActions.getInternalCourses());
        //  }
    }

    //Funcion para filtrar courses
    const handleSearchComunicationProgram = (cm) => {
        //    if (email !== '') {
        dispatch(UserSearchActions.getInternalComunicationPrograms());
        //  }
    }

    const findTechnical = (params, v) => {
        let values = [...new Set(v)];
        let temp = [];
        for (let i = 0; i < values.length; i++) {
            let id = params.technical[values[i]].idResponsible;
            params.technical.forEach((v) => {
                if (v.idResponsible === id) {
                    temp.push(v);
                }
            });
        }
        setRevisor(temp[0].responsibleName);
    }

    const SelectItem = (name = [], value) => {
        if (name == null) name = [];
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    //Componente funcional
    return (
        <div>
            <Modal
                title="Nombre del Revisor del documento (Representante técnico)"
                visible={openModal}
                onOk={() => exportGenerate()}
                onCancel={
                    () => {
                        setOpenModal(false);
                        setRevisor("")
                    }}
                okText="Generar"
                cancelText="Cancelar"
                okButtonProps={{ disabled: revisor == "" }}
            >
                <TechnicalRepresentativeContainer>
                    {(params) => {
                        return (

                            <TextInput
                                text=''
                                color='darker'
                                size='label'
                                weight='medium'
                                placeholder='Selecciona revisor'
                                style={styles.inputSelect}
                                showSearch
                                onChange={(v) => {
                                    findTechnical(params, v);
                                }}
                            >
                                {SelectItem(params.technical, 'responsibleName')}
                            </TextInput>
                        )
                    }}
                </TechnicalRepresentativeContainer>
            </Modal>
            <div hidden={collapse}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={6} >
                        <TextEvents
                            text='Subdirección:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingSubdirection}
                            placeholder="[Selecione Subdirección]"
                            showSearch
                            onChange={onEmployeesSubdirectionChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesSubdirection}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Nombre:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingInternalEmployeesNames}
                            placeholder="[Selecione Colaborador]"
                            showSearch
                            onChange={onEmployeesNamesChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            //filterOption={(input, option) => { seekCollaborators(input, option) }}
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            //size="small"
                            onSearch={debounce(handleSearchName, 500)}
                            mode="multiple"
                        >
                            {optionInternalEmployeesNames}
                        </Select>
                    </Grid>

                    <Grid item xs={6} >
                        <TextEvents
                            text='Ficha:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingEmployeeId}
                            placeholder="[Selecione ficha]"
                            showSearch
                            onChange={onEmployeesIdChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            // filterOption={(input, option) =>
                            //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={debounce(handleSearchFile, 500)}
                            mode="multiple"
                        >
                            {optionInternalEmployeesId}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Compañia:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingEmployeeCompany}
                            placeholder="[Selecione Compañia]"
                            showSearch
                            onChange={onEmployeesCompanyChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesCompany}
                        </Select>
                    </Grid>

                    <Grid item xs={6} >
                        <TextEvents
                            text='Puesto:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingEmployeeCategory}
                            placeholder="[Selecione Puesto]"
                            showSearch
                            onChange={onEmployeesCategoryChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            // filterOption={(input, option) =>
                            //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={debounce(handleSearchCategory, 500)}
                            mode="multiple"
                        >
                            {optionInternalEmployeesCategory}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Contrato:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingContract}
                            placeholder="[Selecione Contrato]"
                            showSearch
                            onChange={onEmployeesContractChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesContract}
                        </Select>
                    </Grid>

                    <Grid item xs={6} >
                        <TextEvents
                            text='OT:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingOT}
                            placeholder="[Selecione OT]"
                            showSearch
                            onChange={onEmployeesOtChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesOT}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Correo electrónico:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingInternalEmail}
                            placeholder="[Selecione correo electrónico]"
                            showSearch
                            onChange={onEmployeesEmailChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            // filterOption={(input, option) =>
                            //     option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            allowClear
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={debounce(handleSearchEmail, 500)}
                            mode="multiple"
                        >
                            {optionInternalEmployeesEmail}
                        </Select>
                    </Grid>

                    <Grid item xs={6}>
                        <TextEvents
                            text='CeCo:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingIECeco}
                            placeholder="[Selecione CeCo]"
                            showSearch
                            onChange={onEmployeesCecoChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesCeco}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='EPEP:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingIEEpep}
                            placeholder="[Selecione EPEP]"
                            showSearch
                            onChange={onEmployeesEpepChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {optionInternalEmployeesEpep}
                        </Select>
                    </Grid>

                    <Grid item xs={6} >
                        <TextEvents
                            text='Activo:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            placeholder="[Selecione]"
                            showSearch
                            onChange={onEmployeesActiveStausChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                        >
                            {[(<Select.Option key={0} value={0}>{'Sí'}</Select.Option>), (<Select.Option key={1} value={-1}>{'No'}</Select.Option>)]}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Pernocta:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingPernocta}
                            placeholder="[Selecione Percnota]"
                            showSearch
                            onChange={onEmployeesPernoctaChange}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                            onSearch={debounce(handleSearchPernocta, 500)}
                        >
                            {optionInternalEmployeesPercnota}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Programas de Comunicacion:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingComunicationProgram}
                            placeholder="[Selecione Programa]"
                            showSearch
                            onChange={onEmployeesComunicationProgramChanges}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                            onSearch={debounce(handleSearchComunicationProgram, 500)}
                        >
                            {optionInternalComunicationProgram}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <TextEvents
                            text='Procedimientos:'
                            color="darker"
                            size='label'
                            weight="medium"
                        />
                        <Select
                            loading={isLoadingCourses}
                            placeholder="[Selecione Procedimiento]"
                            showSearch
                            onChange={onEmployeesCoursesChanges}
                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                            optionFilterProp="Children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            mode="multiple"
                            onSearch={debounce(handleSearchCourses, 500)}
                        >
                            {optionInternalCourses}
                        </Select>
                    </Grid>

                </Grid>
            </div>
            {/*Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                {
                    collapse ?
                        <Tooltip title={"Mostrar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(false)}
                            >
                                <Icon type="down" />
                            </Button>
                        </Tooltip> :
                        <Tooltip title={"Ocultar filtro"}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="link"
                                onClick={() => setCollapse(true)}
                            >
                                <Icon type="up" />
                            </Button>
                        </Tooltip>
                }
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    loading={isExportingXls} //uphere
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
                <Button
                    className={classes.button}
                    variant="contained"
                    loading={isExportingBookmarkXls}
                    disabled={employeesNames.length == 0 && employeesId.length == 0}
                    type="primary"
                    onClick={() => setOpenModal(true)}
                >
                    Generar
                </Button>
            </div>
        </div>
    );
}

export default InternalEmployeesFilterComponent;
